export const CONTENT_TYPES = {
    BULLETS: 'bullets',
    Text: 'text',
    TABLE: 'table',
    TIMELINE: 'timeline',
    STAKEHOLDER_IMPACT: 'stakeholder_impact',
    SCENARIO: 'scenario',
    CONCEPTS_DECODED: 'concepts_decoded'
}